import React from 'react';
import {
	IDropdownItem,
	StyledTextFieldLabel,
	StyledTextFieldLabelText,
	StyledTextFieldHint,
} from '../../../../ui';
import {
	ControlledAutoSuggest,
	IControlledAutoSuggestProps,
} from './ControlledAutoSuggest';

export interface IAutoSuggestFieldProps<
	TItemType extends IDropdownItem = IDropdownItem,
> extends IControlledAutoSuggestProps<TItemType> {
	label: string;
	hint?: string;
}

export const AutoSuggestField = <TItemType extends IDropdownItem>({
	label,
	hint,
	...rest
}: IAutoSuggestFieldProps<TItemType>) => (
	<StyledTextFieldLabel>
		<StyledTextFieldLabelText>
			{label} {hint && <StyledTextFieldHint>{hint}</StyledTextFieldHint>}
		</StyledTextFieldLabelText>
		<ControlledAutoSuggest {...rest} ariaLabel={label} />
	</StyledTextFieldLabel>
);
